import { Tag, Tooltip } from "antd";
import { ShareAltOutlined, LinkOutlined } from "@ant-design/icons";

interface ShareBadgeProps {
  type?: "shared" | "link";
  tooltip?: string;
}

export default function ShareBadge({
  type = "shared",
  tooltip,
}: ShareBadgeProps) {
  const badge = (
    <Tag
      icon={type === "link" ? <LinkOutlined /> : <ShareAltOutlined />}
      color="blue"
      style={{
        margin: 0,
        borderRadius: 4,
        fontSize: 11,
        padding: "0 6px",
        lineHeight: "18px",
      }}
    >
      {type === "link" ? "Link" : "Shared"}
    </Tag>
  );

  if (tooltip) {
    return <Tooltip title={tooltip}>{badge}</Tooltip>;
  }

  return badge;
}
